export default __webpack_public_path__ + "static/media/material-email-icon.c3e0b106.svg";